export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '11e4c89a-3670-420b-b23a-7458bbf5ad05';
export const MODAL_CLOSE_SEC = 2.5;
